import { styled } from 'parkdepot-shared/theme'

export const SpinnerContainer = styled('div', ({ $theme }) => ({
    padding: `0 ${$theme.sizing.scale700}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}))

export const Title = styled('h2', ({ $theme }) => ({
    ...$theme.typography.LabelSmall,
    fontWeight: 700,
    margin: 0,
    textAlign: 'center'
}))

export const Text = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0
}))
